<template>
  <div class="about Publications">

      <section id="portada" class="animacion">
        <div class="contedor-portada">
          <div class="portada-contenido animacion">
          <h1>{{nom_sub_sec_es}}</h1>
          <ul>
            <li><router-link tag="a" to="/">Inicio</router-link></li>
            <li class="sin-division">{{nom_sub_sec_es}}</li>
          </ul>
          </div>
          <img
            class="imagen-cover"
            v-bind:src='imgPreUrl+ url_1st_image +"x640.jpg"'
            v-bind:alt='type_1st_image'>
        </div>
      </section>

      <section id="servicios" class="secciones seccion-blanca">        
        <div class="container">
          <h1>{{internal_name_es}}</h1>
            <span v-html="desc_sub_section_es"></span>

          <div class="row">

            <div class="col-sm-6 col-md-4 col-lg-3 text-center" v-for="(item, index) in item_list" :key="index">
              <div class="servicios-home animacion">
                <a v-bind:href="item.button_url" target="_blank" class="servicios-home-foto">
                  <img class="imagen-cover" v-bind:src='imgPreUrl+ item.url_image +"x320.jpg"' alt="portada catálogo">
                </a>
                <a v-bind:href="item.button_url" target="_blank" class="servicios-home-texto animacion" style="text-decoration: none;">
                  <h2>{{item.title_item_es}}</h2>
                </a>
              <div class="servicios-home-boton animacion"><a v-bind:href="item.button_url" target="_blank" class="btn-al btn-al-md btn-al-celeste-solid" style="text-decoration: none;">{{item.text_button_es}}</a></div>
              </div>
            </div>
          
          </div>

         

            <div class="col-xs-12">
             
              <ul role="menubar" aria-disabled="false" aria-label="Pagination" class="pagination b-pagination pagination-sm center-page">
                <template v-if="current_page == 1">
                  <li role="none presentation" class="page-item disabled"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">«</span></a></li>
                </template>
                <template v-else>
                  <li role="none presentation" class="page-item" @click="listadoPagina(1)"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">«</span></a></li>
                </template>
                <template v-if="current_page > 1">
                  <li role="none presentation" class="page-item" aria-hidden="true" @click="listadoPagina(current_page - 1)"><span class="page-link page-selector">‹</span></li>
                </template>
                <template v-else>
                  <li role="none presentation" class="page-item disabled" aria-hidden="true"><span class="page-link page-selector" >‹</span></li>
                </template>
                <li v-for="page in pages" :key="page" role="none presentation" :class="['page-item', (page === current_page) ? 'active' : '']" @click="listadoPagina(page)"><a role="menuitemradio" tabindex="-1" aria-label="Goto page 2" aria-checked="false" aria-posinset="2" aria-setsize="4" target="_self" class="page-link page-selector">{{page}}</a></li>
                <template v-if="current_page == final_page">
                  <li role="none presentation" class="page-item disabled"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">›</span></a></li>
                </template>
                <template v-else>
                  <li role="none presentation" class="page-item" @click="listadoPagina(current_page + 1)"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">›</span></a></li>
                </template>
                <template v-if="current_page == final_page">
                  <li role="none presentation" class="page-item disabled"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link"><span class="page-selector" aria-hidden="true">»</span></a></li>
                </template>
                <template v-else>
                  <li role="none presentation" class="page-item" @click="listadoPagina(final_page)"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link"><span class="page-selector" aria-hidden="true">»</span></a></li>
                </template>
              </ul>
              
           </div>

          <!--
          <div class="col-xs-12">
            <div class="paginador text-center">
              <ul>
                <li><a class="pag-ant pag-desactivado">«</a></li>
                <li><a href="" class="pag-item active">1</a></li>
                <li><a class="pag-sig pag-desactivado">»</a></li>
              </ul>              
            </div>
          </div>
          -->
          
        </div>
                 
      </section>
    
    <TwoModules></TwoModules>
    <Instagram></Instagram>

  </div>
</template>

<script>
import TwoModules from "@/components/products/TwoModules.vue";
import Instagram from "@/components/products/Instagram.vue";
import axios from "axios";
import {config_settings} from '@/config.js';
import _ from "lodash";
import { errorToaster } from '@/components/shared/service/ErrorHandler';

//HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const INTERNAL_SERVER_ERROR = 500;

  axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  components: {
    TwoModules,
    Instagram
  },
  data() {
    return {
    imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
    cod_sub_sec: 3,
    nom_sub_sec_es: '',
    nom_sub_sec_en: '',
    internal_name_es: '',
    internal_name_en: '',
    desc_sub_section_es: '',
    desc_sub_section_en: '',
    section: '',
    url_1st_image: 'products/empty-img',
    url_2nd_image: 'products/empty-img',
    url_3rd_image: 'products/empty-img',
    url_4th_image: 'products/empty-img',
    url_5th_image: 'products/empty-img',
    type_1st_image: 'image',
    type_2nd_image: 'image',
    type_3rd_image: 'image',
    type_4th_image: 'image',
    type_5th_image: 'image',
    text1_es: '',
    text1_en: '',
    text2_es: '',
    text2_en: '',
    text3_es: '',
    text3_en: '',
    orientation: '',
    url_es: '',
    url_en: '',
    order_sub_section: '',
    id_position_menu: '',
    url_video: '',
    type: '' ,

    item_list: [],
    crit: 8,
    pages: [],
    final_page: 1,
    current_page: 1
    }
  },
  methods: {
    obtener_sub_section_data(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec)
           .then(response => {
              
              this.nom_sub_sec_es = response.data.nom_sub_sec_es
              this.nom_sub_sec_en = response.data.nom_sub_sec_en
              this.internal_name_es = response.data.internal_name_es
              this.internal_name_en  = response.data.internal_name_en  
              this.desc_sub_section_es = response.data.desc_sub_section_es  
              this.desc_sub_section_en = response.data.desc_sub_section_en  
              this.section = response.data.section  
              this.url_1st_image = response.data.url_1st_image  
              this.url_2nd_image = response.data.url_2nd_image  
              this.url_3rd_image = response.data.url_3rd_image  
              this.url_4th_image = response.data.url_4th_image  
              this.url_5th_image = response.data.url_5th_image  
              this.type_1st_image = response.data.type_1st_image  
              this.type_2nd_image = response.data.type_2nd_image  
              this.type_3rd_image = response.data.type_3rd_image  
              this.type_4th_image = response.data.type_4th_image  
              this.type_5th_image = response.data.type_5th_image  
              this.text1_es = response.data.text1_es  
              this.text1_en = response.data.text1_en 
              this.text2_es = response.data.text2_es  
              this.text2_en = response.data.text2_en  
              this.text3_es = response.data.text3_es  
              this.text3_en = response.data.text3_en  
              this.orientation = response.data.orientation  
              this.url_es = response.data.url_es  
              this.url_en = response.data.url_en  
              this.order_sub_section = response.data.order_sub_section  
              this.id_position_menu = response.data.id_position_menu  
              this.url_video = response.data.url_video 
              this.type = response.data.type 
             
          })
           .catch(error => {
            console.log("error");
      })
    },

    scroll_inicio(){
      window.scrollTo(0,0);
    },
  
    obtener_items(){
        axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec +'/items_all')
            .then(response => {
                this.item_list = response.data
                console.log(JSON.stringify(response.data));
            })
            .catch(error => {
              console.log("error");
        })
    },

    obtener_items_paginado(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec +'/items')
           .then(response => {
             //this.crit = 10
             this.item_list = response.data.items;
             this.pages = response.data.visible_pages
             this.final_page = response.data.final_page
             this.current_page = 1
           })
           .catch(error => {
             console.log(error)
            //this.mensaje_error = "No se encontraron resultados de la busqueda filtrada.";
            //this.mensaje = "";
           })
    },

    listadoPagina(page){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec +'/items?cReg=8'+'&&nPag='+page)
           .then(response => {
             var arreglo = response.data.items
             if(arreglo.length==0){
              this.listadoPagina(page - 1)
             }

             this.item_list = arreglo
             this.pages = response.data.visible_pages
             this.final_page = response.data.final_page
             this.current_page = page
             //this.mensaje_error = ""
             //this.mensaje = ""
           })
           .catch(error => {
             //this.loading = false;
             if (error.response.status === NOT_FOUND){
                this.listadoPagina(page-1);
             }  
             else {
                toastr.error(error.response.data.details,
                       error.response.data.message,
                       {"iconClass": 'customer-danger'});
             }  
           })
    }
  
  },

  created() {
    this.scroll_inicio();
    this.obtener_sub_section_data();
    //this.obtener_items();
    //this.obtener_items_paginado()
    this.listadoPagina(1)
  }
};
</script>

<style lang="scss" src="./Publications.scss"></style>
